import { FC } from 'react';
import { Skeleton, SkeletonAvatar, SkeletonText } from '@components/atoms/Skeleton';
import { cn } from '@utils/cn';

interface ActivityCardSkeletonProps {
  className?: string;
}

/**
 * Placeholder for a single activity card in the feed. Mirrors the card chrome
 * (avatar + header + body) so the loading state reads as "content is coming",
 * not "spinner in the void". Composes the Skeleton atom family.
 */
export const ActivityCardSkeleton: FC<ActivityCardSkeletonProps> = ({ className }) => (
  <div
    className={cn(
      'w-full rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 p-4',
      className,
    )}
    aria-hidden="true"
  >
    <div className="flex items-start gap-3">
      <SkeletonAvatar size="md" />
      <div className="flex-1 space-y-2">
        <div className="flex items-center gap-2">
          <Skeleton height={14} width="30%" />
          <Skeleton height={12} width={64} />
        </div>
        <SkeletonText lines={2} spacing="sm" />
      </div>
    </div>
  </div>
);

export default ActivityCardSkeleton;
